import React from "react";
import Link from "next/link";
import { excerpt } from "@unisearch/helpers/utils";
import moment from "moment";
import { MdPlayCircle } from "react-icons/md";
import styles from "./news_video_card.module.scss";
import { getAssets } from "@unisearch/helpers";

/* 
For Custom Classes Props it takes
customClasses={
  cardClass:styles.[your custom class name],
  headClass: styles.[your custom class name],
  bodyClass: styles.[your custom class name],
  featureImageClass: styles.[your custom class name],
  titleClass: styles.[your custom class name],
  dateClass: styles.[your custom class name],
  playIconClass: styles.[your custom class name],
  descriptionClass: styles.[your custom class name],
}
*/

export const NewsVideoCard = ({
  data,
  customClasses,
  showDescription = false,
  ...props
}) => {
  return (
    <div
      className={`${styles.video_card} ${
        customClasses?.cardClass ? customClasses?.cardClass : ""
      }`}
    >
      <div
        className={`${styles.video_card_head} ${
          customClasses?.headClass ? customClasses?.headClass : ""
        }`}
      >
        <Link legacyBehavior href={`/news/video/${data?.slug}`}>
          <a
            className={`${styles.video_card_image_wrapper} ${
              customClasses?.featureImageClass
                ? customClasses?.featureImageClass
                : ""
            }`}
          >
            <MdPlayCircle
              className={`${styles.video_card_play_icon} ${
                customClasses?.playIconClass ? customClasses?.playIconClass : ""
              }`}
            />
            <img
              src={
                data?.featureImage?.src ||
                getAssets("assets/images/image_placeholder_big.webp")
              }
              alt=""
            />
          </a>
        </Link>
      </div>
      <div
        className={`${
          customClasses?.bodyClass ? customClasses?.bodyClass : ""
        }`}
      >
        <Link legacyBehavior href={`/news/video/${data?.slug}`}>
          <a
            className={`${styles.video_card_title} ${
              customClasses?.titleClass ? customClasses?.titleClass : ""
            }`}
          >
            {data?.newsTitle}
          </a>
        </Link>
        <div
          className={`${styles.video_card_date} ${
            customClasses?.dateClass ? customClasses?.dateClass : ""
          }`}
        >
          {data?.author && (
            <>
              <span>{data?.author?.name}</span>
              <span>{" - "}</span>
            </>
          )}

          {data?.publishDate && (
            <span>{moment(data?.publishDate).format("MMMM DD, YYYY")}</span>
          )}
        </div>

        {showDescription && (
          <div
            className={`${styles.video_card_description} ${
              customClasses?.descriptionClass
                ? customClasses?.descriptionClass
                : ""
            }`}
          >
            {data?.shortDescription
              ? excerpt(data.shortDescription, 200)
              : data?.newsContent
              ? excerpt(data?.newsContent, 200)
              : ""}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsVideoCard;
